/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var People1BossIcon20Solid = forwardRef('People1BossIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M10 10.335A4.167 4.167 0 1 0 10 2a4.167 4.167 0 0 0 0 8.335Z" }),
        React.createElement("path", { d: "M2.173 16.369c.578-2.511 2.515-3.586 4.47-4.042L7.813 15l-.875 3H3.64c-.906 0-1.671-.748-1.468-1.631Z" }),
        React.createElement("path", { d: "m12.188 15 1.169-2.673c1.955.456 3.891 1.53 4.47 4.042.203.883-.562 1.631-1.468 1.631h-3.297l-.874-3Z" }),
        React.createElement("path", { d: "m9.375 14.5-1.03 3.708a.625.625 0 0 0 .602.792h2.106a.625.625 0 0 0 .602-.792l-1.03-3.708c.725-.607.988-1.128 1.185-2.137a.306.306 0 0 0-.304-.363H8.5a.31.31 0 0 0-.305.369c.197.989.396 1.46 1.18 2.131Z" })));
});
